import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { stopPropagation } from '../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { FloatingTooltip } from '../../Floating'

import * as styles from './ProfileActionsWidgetItem.module.css'

function ProfileActionsWidgetItem({
  className = styles.ProfileActionsWidgetItem,
  disabled,
  height = BUTTON_HEIGHT_32,
  isGrey = true,
  tooltip,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  value,
  onClick,
  ...restProps
}) {
  function handleClick(event) {
    stopPropagation(event)

    onClick({ event, value })
  }

  // Native disabled suppresses hover, so the tooltip moves to an enabled wrapper
  const withTooltipOnWrapper = disabled && Boolean(tooltip)

  const button = (
    <Button.Flat
      {...restProps}
      className={className}
      disabled={disabled}
      height={height}
      isGrey={isGrey}
      tooltip={withTooltipOnWrapper ? undefined : tooltip}
      tooltipPlacement={tooltipPlacement}
      onClick={handleClick}
    />
  )

  if (withTooltipOnWrapper) {
    return (
      <FloatingTooltip content={tooltip} placement={tooltipPlacement}>
        <span className={styles.tooltipWrapper}>{button}</span>
      </FloatingTooltip>
    )
  }

  return button
}

export default ProfileActionsWidgetItem
